import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'KING',
  description:
    'The most popular AMM on BSC by user count! Earn CAKE through yield farming or win it in the Lottery, then stake it in KING Pools to earn more tokens! Initial Farm Offerings (new token launch model pioneered by KING), NFTs, and more, on a platform you can trust.',
  image: 'https://thekingslife.finance/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else if (path.startsWith('/nfts/collections')) {
    basePath = '/nfts/collections'
  } else if (path.startsWith('/nfts/profile')) {
    basePath = '/nfts/profile'
  } else if (path.startsWith('/pancake-squad')) {
    basePath = '/pancake-squad'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `Thekingslife | ${t('Home')}`,
      }
    case '/swap':
      return {
        title: `Thekingslife | ${t('Exchange')}`,
      }
    case '/add':
      return {
        title: `Thekingslife | ${t('Add Liquidity')}`,
      }
    case '/remove':
      return {
        title: `Thekingslife | ${t('Remove Liquidity')}`,
      }
    case '/liquidity':
      return {
        title: `Thekingslife | ${t('Liquidity')}`,
      }
    case '/find':
      return {
        title: `Thekingslife | ${t('Import Pool')}`,
      }
    case '/competition':
      return {
        title: `Thekingslife | ${t('Trading Battle')}`,
      }
    case '/prediction':
      return {
        title: `Thekingslife | ${t('Prediction')}`,
      }
    case '/prediction/leaderboard':
      return {
        title: `Thekingslife | ${t('Leaderboard')}`,
      }
    case '/farms':
      return {
        title: `Thekingslife | ${t('Farms')}`,
      }
    case '/farms/auction':
      return {
        title: `Thekingslife | ${t('Farm Auctions')}`,
      }
    case '/pools':
      return {
        title: `Thekingslife | ${t('Pools')}`,
      }
    case '/lottery':
      return {
        title: `Thekingslife | ${t('Lottery')}`,
      }
    case '/ifo':
      return {
        title: `Thekingslife | ${t('Initial Farm Offering')}`,
      }
    case '/teams':
      return {
        title: `Thekingslife | ${t('Leaderboard')}`,
      }
    case '/voting':
      return {
        title: `Thekingslife | ${t('Voting')}`,
      }
    case '/voting/proposal':
      return {
        title: `Thekingslife | ${t('Proposals')}`,
      }
    case '/voting/proposal/create':
      return {
        title: `Thekingslife | ${t('Make a Proposal')}`,
      }
    case '/info':
      return {
        title: `Thekingslife | ${t('Overview')} | ${t('Thekingslife Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/info/pools':
      return {
        title: `Thekingslife | ${t('Pools')} | ${t('Thekingslife Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/info/tokens':
      return {
        title: `Thekingslife | ${t('Tokens')} | ${t('Thekingslife Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/nfts':
      return {
        title: `Thekingslife | ${t('Overview')}`,
      }
    case '/nfts/collections':
      return {
        title: `${t('Collections')}`,
      }
    case '/nfts/profile':
      return {
        title: `${t('Your Profile')}`,
      }
    case '/pancake-squad':
      return {
        title: `${t('Pancake Squad')}`,
      }
    default:
      return null
  }
}
